import { Box, Grid, Pagination } from '@mui/material';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { PendingRespondentStatusMap } from 'src/@types/pendingRespondentStatus';
import { HeaderBreadcrumbsProps } from 'src/components/HeaderBreadcrumbs';
import { PageLayout } from 'src/components/app-components/PageLayout';
import { IdIssuanceManagementDetail } from './IdIssuanceManagementDetail';
import { IdIssuanceManagementGrid } from './IdIssuanceManagementGrid';
import { IdIssuanceManagementSearchForm } from './IdIssuanceManagementSearchForm';
import { useIdIssuanceManagementList } from './hooks/useIdIssuanceManagementList';
import { actions } from './utils/searchState';

type IdIssuanceManagementListLayoutProps = {
  pageTitle: string;
  breadCrumbs: HeaderBreadcrumbsProps;
};

export const IdIssuanceManagementList = ({ pageTitle, breadCrumbs }: IdIssuanceManagementListLayoutProps) => {
  const { t } = useTranslation();
  const { fetchPendingRespondents, searchParams, dispatch, setSelectedUser, selectedUser, fetchResult, loading } = useIdIssuanceManagementList();

  const statusMap: PendingRespondentStatusMap = {
    ALL: t('idIssuanceStatus.all'),
    ISSUED: t('idIssuanceStatus.issued'),
    MAIL_SENT: t('idIssuanceStatus.mailSent'),
    AGREED: t('idIssuanceStatus.agreed'),
    REGISTERED: t('idIssuanceStatus.registered'),
  };

  const onPageChange = (_: ChangeEvent<unknown>, value: number) => {
    dispatch(actions.setCurrentPage(value));
    fetchPendingRespondents({ ...searchParams, currentPage: value });
  };

  const renderContent = () => {
    if (selectedUser) {
      return <IdIssuanceManagementDetail selectedUser={selectedUser} setSelectedUser={setSelectedUser} statusMap={statusMap} key={selectedUser.id} />;
    }
    return (
      <>
        <IdIssuanceManagementSearchForm
          statusMap={statusMap}
          fetchPendingRespondents={fetchPendingRespondents}
          searchParams={searchParams}
          dispatch={dispatch}
          loading={loading}
        />
        <IdIssuanceManagementGrid
          rowData={fetchResult.rowData}
          statusMap={statusMap}
          setSelectedUser={setSelectedUser}
          fetchPendingRespondents={fetchPendingRespondents}
          searchParams={searchParams}
          dispatch={dispatch}
        />
        <Grid container sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2 }}>
          {fetchResult.rowData.length > 0 && <Pagination count={fetchResult.totalPages} page={searchParams.currentPage} onChange={onPageChange} />}
        </Grid>
      </>
    );
  };

  return (
    <PageLayout title={pageTitle} breadcrumbs={breadCrumbs}>
      <Box sx={{ mt: 2 }}>{renderContent()}</Box>
    </PageLayout>
  );
};
